import Users from './Users';
import ChangePassword from './ChangePassword';

export { ChangePassword };
export default Users;
